// extracted by mini-css-extract-plugin
export var hideEditor = "_kb-2";
export var infoIcon = "_kb-3";
export var label = "_kb-1";
export var labelContainer = "_kb-0";
export var readonlyText = "_kb-4";